import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { isUndefined } from "lodash";
const _2_xx_31 = 2 ** 31; // 2_147_483_648;
const _2_xx_32 = 2 ** 32; // 4_294_967_296;
var FormatNumber;
(function (FormatNumber) {
  FormatNumber[FormatNumber["Format1"] = 0] = "Format1";
  FormatNumber[FormatNumber["Format2"] = 1] = "Format2";
})(FormatNumber || (FormatNumber = {}));
var FormatPart;
(function (FormatPart) {
  FormatPart[FormatPart["Part1"] = 0] = "Part1";
  FormatPart[FormatPart["Part2"] = 1] = "Part2";
})(FormatPart || (FormatPart = {}));
class FormatLookup {
  // Masks for the fields on the part1 of gridFormat1

  // Masks for the fields on the part2 of gridFormat1

  // Masks for the fields on the part1 of gridFormat2

  constructor(number, part, mask) {
    this.number = number;
    this.part = part;
    this.mask = mask;
  }
}
_defineProperty(FormatLookup, "FONT_WEIGHT", new FormatLookup(FormatNumber.Format1, FormatPart.Part1, 3));
_defineProperty(FormatLookup, "ITALIC_STYLE", new FormatLookup(FormatNumber.Format1, FormatPart.Part1, 12));
_defineProperty(FormatLookup, "UNDERLINE_STYLE", new FormatLookup(FormatNumber.Format1, FormatPart.Part1, 48));
_defineProperty(FormatLookup, "TEXT_WRAP", new FormatLookup(FormatNumber.Format1, FormatPart.Part1, 192));
_defineProperty(FormatLookup, "ALIGN_HORIZONTAL", new FormatLookup(FormatNumber.Format1, FormatPart.Part1, 768));
_defineProperty(FormatLookup, "ALIGN_VERTICAL", new FormatLookup(FormatNumber.Format1, FormatPart.Part1, 3072));
_defineProperty(FormatLookup, "NUMBER_FORMAT", new FormatLookup(FormatNumber.Format1, FormatPart.Part1, 12288));
_defineProperty(FormatLookup, "THOUSAND_SEPARATOR", new FormatLookup(FormatNumber.Format1, FormatPart.Part1, 49152));
_defineProperty(FormatLookup, "CURRENCY", new FormatLookup(FormatNumber.Format1, FormatPart.Part1, 2031616));
_defineProperty(FormatLookup, "NEGATIVE_STYLE", new FormatLookup(FormatNumber.Format1, FormatPart.Part1, 14680064));
_defineProperty(FormatLookup, "DECIMAL_COUNT", new FormatLookup(FormatNumber.Format1, FormatPart.Part1, 251658240));
_defineProperty(FormatLookup, "COLOR_FOREGROUND", new FormatLookup(FormatNumber.Format1, FormatPart.Part2, 63));
_defineProperty(FormatLookup, "COLOR_BACKGROUND", new FormatLookup(FormatNumber.Format1, FormatPart.Part2, 4032));
_defineProperty(FormatLookup, "FONT_FAMILY", new FormatLookup(FormatNumber.Format1, FormatPart.Part2, 61440));
_defineProperty(FormatLookup, "FONT_SIZE", new FormatLookup(FormatNumber.Format1, FormatPart.Part2, 4128768));
_defineProperty(FormatLookup, "TASKBAR_COLOR", new FormatLookup(FormatNumber.Format2, FormatPart.Part1, 63));
_defineProperty(FormatLookup, "DATE_FORMAT", new FormatLookup(FormatNumber.Format2, FormatPart.Part1, 1984));
const FORMAT_LOOKUP_BY_FORMAT_NAME = {
  backgroundColor: FormatLookup.COLOR_BACKGROUND,
  currency: FormatLookup.CURRENCY,
  dateFormat: FormatLookup.DATE_FORMAT,
  decimalCount: FormatLookup.DECIMAL_COUNT,
  fontFamily: FormatLookup.FONT_FAMILY,
  fontSize: FormatLookup.FONT_SIZE,
  fontWeight: FormatLookup.FONT_WEIGHT,
  foregroundColor: FormatLookup.COLOR_FOREGROUND,
  horizontalAlignment: FormatLookup.ALIGN_HORIZONTAL,
  italicStyle: FormatLookup.ITALIC_STYLE,
  negativeStyle: FormatLookup.NEGATIVE_STYLE,
  numberFormat: FormatLookup.NUMBER_FORMAT,
  taskbarColor: FormatLookup.TASKBAR_COLOR,
  textWrap: FormatLookup.TEXT_WRAP,
  thousandsSeparator: FormatLookup.THOUSAND_SEPARATOR,
  underlineStyle: FormatLookup.UNDERLINE_STYLE,
  verticalAlignment: FormatLookup.ALIGN_VERTICAL
};
const isKeyOf = (x, k) => {
  return k in x;
};
export const encodeFormat = encodedFormatValues => {
  let updatedFormat = {
    format1: 0,
    format2: 0
  };
  Object.entries(FORMAT_LOOKUP_BY_FORMAT_NAME).forEach(_ref => {
    let [styleKey, currentFormatLookup] = _ref;
    if (isKeyOf(encodedFormatValues, styleKey) && isKeyOf(FORMAT_LOOKUP_BY_FORMAT_NAME, styleKey)) {
      const encodedFormatValue = encodedFormatValues[styleKey];
      if (isUndefined(encodedFormatValue)) {
        return updatedFormat;
      }
      updatedFormat = encodeFormatValue(updatedFormat, currentFormatLookup, encodedFormatValue);
    }
  });
  return updatedFormat;
};
export const getFormatLookups = encodedFormat => ({
  backgroundColor: getFormatLookupNumber(encodedFormat, FormatLookup.COLOR_BACKGROUND),
  currency: getFormatLookupNumber(encodedFormat, FormatLookup.CURRENCY),
  dateFormat: getFormatLookupNumber(encodedFormat, FormatLookup.DATE_FORMAT),
  decimalCount: getFormatLookupNumber(encodedFormat, FormatLookup.DECIMAL_COUNT),
  fontFamily: getFormatLookupNumber(encodedFormat, FormatLookup.FONT_FAMILY),
  fontSize: getFormatLookupNumber(encodedFormat, FormatLookup.FONT_SIZE),
  fontWeight: getFormatLookupNumber(encodedFormat, FormatLookup.FONT_WEIGHT),
  foregroundColor: getFormatLookupNumber(encodedFormat, FormatLookup.COLOR_FOREGROUND),
  horizontalAlignment: getFormatLookupNumber(encodedFormat, FormatLookup.ALIGN_HORIZONTAL),
  italicStyle: getFormatLookupNumber(encodedFormat, FormatLookup.ITALIC_STYLE),
  negativeStyle: getFormatLookupNumber(encodedFormat, FormatLookup.NEGATIVE_STYLE),
  numberFormat: getFormatLookupNumber(encodedFormat, FormatLookup.NUMBER_FORMAT),
  taskbarColor: getFormatLookupNumber(encodedFormat, FormatLookup.TASKBAR_COLOR),
  textWrap: getFormatLookupNumber(encodedFormat, FormatLookup.TEXT_WRAP),
  thousandsSeparator: getFormatLookupNumber(encodedFormat, FormatLookup.THOUSAND_SEPARATOR),
  underlineStyle: getFormatLookupNumber(encodedFormat, FormatLookup.UNDERLINE_STYLE),
  verticalAlignment: getFormatLookupNumber(encodedFormat, FormatLookup.ALIGN_VERTICAL)
});

/**
 * This function allows us to use all 32 bits of a signed int for a bit mask
 * by treating it as an unsigned int and converting to a signed float
 */
function convertSigned32IntToFloat(int32) {
  // 2147483647 = mask to remove signed bit
  // 2147483648 = adds the signed bit back as a positive float
  if (int32 < 0) {
    int32 = (int32 & _2_xx_31 - 1) + _2_xx_31;
  }
  return int32;
}
const getPart1OfFormatNumber = formatNumber => {
  return convertSigned32IntToFloat(formatNumber & _2_xx_32 - 1);
};
const getPart2OfFormatNumber = formatNumber => {
  return formatNumber / _2_xx_32 | 0;
};
export const encodeFormatValue = (encodedFormat, formatLookup, encodedFormatValue) => {
  const formatKey = formatLookup.number === FormatNumber.Format1 ? "format1" : "format2";
  let formatPart1 = getPart1OfFormatNumber(encodedFormat[formatKey]);
  let formatPart2 = getPart2OfFormatNumber(encodedFormat[formatKey]);
  if (formatLookup.part === FormatPart.Part1) {
    formatPart1 &= ~formatLookup.mask;
    formatPart1 |= encodedFormatValue;
    formatPart1 = convertSigned32IntToFloat(formatPart1);
  } else {
    formatPart2 &= ~formatLookup.mask;
    formatPart2 |= encodedFormatValue;
  }
  return {
    ...encodedFormat,
    [formatKey]: formatPart1 + formatPart2 * _2_xx_32
  };
};
const getFormatLookupNumber = (encodedFormat, formatType) => {
  let whichFormatingNumberToUse;
  switch (formatType.number) {
    case FormatNumber.Format1:
      whichFormatingNumberToUse = encodedFormat.format1;
      break;
    case FormatNumber.Format2:
      whichFormatingNumberToUse = encodedFormat.format2;
      break;
  }
  let encodedFormatValueSection;
  switch (formatType.part) {
    case FormatPart.Part1:
      encodedFormatValueSection = convertSigned32IntToFloat(whichFormatingNumberToUse & _2_xx_32 - 1);
      break;
    case FormatPart.Part2:
      encodedFormatValueSection = whichFormatingNumberToUse / _2_xx_32 | 0;
      break;
  }
  return convertSigned32IntToFloat(encodedFormatValueSection & formatType.mask);
};
//# sourceMappingURL=formatEncoding.js.map